import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = ['Explicar tus sentimientos solo le dio más poder y validó su ego.', 'Reclamarle por su falta de atención te hizo ver desesperada ante sus ojos.', 'Ser la "novia/amiga perfecta" borró el misterio que lo atrajo al principio.', 'Esperar su mensaje te convirtió en un satélite que gira alrededor de su vida.'];
  return <section className="py-20 bg-dark-100/50 relative" data-id="element-37">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-16" data-id="element-40">
            Por qué lo que intentaste{' '}
            <span className="text-gold-400 italic" data-id="element-41">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-42">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-43">
              <div className="flex items-start gap-4 p-6 bg-dark border border-white/5 rounded-sm hover:border-gold-500/30 transition-colors duration-300" data-id="element-44">
                <div className="mt-1 bg-red-900/20 p-1 rounded-full flex-shrink-0" data-id="element-45">
                  <X className="w-5 h-5 text-red-400" data-id="element-46" />
                </div>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-47">
                  {attempt}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}